export const navLinks = [
  { label: '更新条', href: '#updates' },
  { label: '热度榜', href: '#ranking' },
  { label: '时间线', href: '#timeline' },
  { label: '话题墙', href: '#topics' },
  { label: '深度分析', href: '#analysis' },
  { label: '讨论区', href: '#community' },
];

export const tickerFeed = [
  '「星野文化」事件补入第 12 个时间线节点 · 2 分钟前',
  '话题墙新增 #合约期限争议 · 6 分钟前',
  '深度分析《把录音按时间轴重排后》已更新 · 11 分钟前',
  '「小满工作室」源头线索回溯到三年前 · 18 分钟前',
  '热度榜本周冠军易主 · 24 分钟前',
];

export const heroStats = [
  { label: '已梳理事件', value: '1,284' },
  { label: '时间线节点', value: '9,602' },
  { label: '深度分析', value: '476' },
  { label: '在讨论话题', value: '318' },
];

export const todayUpdates = [
  {
    id: 'u1',
    tag: '新节点',
    time: '2 分钟前',
    title: '「星野文化」补入第 12 个节点：三方联合声明原文已归档',
    desc: '声明里被删掉的那一段重新对回时间轴，恰好卡在旧版本发布前两小时。',
  },
  {
    id: 'u2',
    tag: '源头回溯',
    time: '18 分钟前',
    title: '「小满工作室」的源头线索往前推了三年',
    desc: '最早的公开记录出现在三年前的一条工作动态里，早于多数人记忆的起点。',
  },
  {
    id: 'u3',
    tag: '证据整理',
    time: '47 分钟前',
    title: '同一段录音的两个版本完成逐句对照',
    desc: '两次公开时长差 41 秒，我们把缺失部分按上下文补回了位置。',
  },
  {
    id: 'u4',
    tag: '走向更新',
    time: '1 小时前',
    title: '事件走向出现拐点：双方首次在同一节点作出回应',
    desc: '这是整条时间线上第一次出现「同日双向回应」，意义大于内容本身。',
  },
];

export const moreUpdates = [
  {
    id: 'u5',
    tag: '话题新增',
    time: '2 小时前',
    title: '话题墙新增「合约期限争议」，已有 34 条补充线索',
    desc: '争议核心从「有没有签」转向「什么时候到期」，讨论方向整体位移。',
  },
  {
    id: 'u6',
    tag: '修正',
    time: '3 小时前',
    title: '更正一条被反复转发的旧截图时间戳',
    desc: '截图实际拍摄时间比流传版本晚 9 天，已按新时间点重排节点顺序。',
  },
  {
    id: 'u7',
    tag: '深度分析',
    time: '5 小时前',
    title: '《为什么这件事每次都在同一个节点引爆》已发布',
    desc: '把四次集中讨论的起点标在同一张时间轴上，重合度比想象中高。',
  },
];

export const rankingToday = [
  { id: 'r1', rank: 1, title: '星野文化 · 三方声明时间线', category: '合约争议', heat: 98, trend: 'up' },
  { id: 'r2', rank: 2, title: '小满工作室 · 源头三年回溯', category: '源头梳理', heat: 91, trend: 'up' },
  { id: 'r3', rank: 3, title: '录音两版本 · 41 秒差额对照', category: '证据整理', heat: 84, trend: 'flat' },
  { id: 'r4', rank: 4, title: '同日双向回应 · 走向拐点', category: '走向更新', heat: 76, trend: 'up' },
  { id: 'r5', rank: 5, title: '旧截图时间戳更正记录', category: '修正公告', heat: 63, trend: 'down' },
  { id: 'r6', rank: 6, title: '粉丝站清空动态 · 前后对照', category: '外围线索', heat: 55, trend: 'flat' },
];

export const rankingWeek = [
  { id: 'w1', rank: 1, title: '小满工作室 · 源头三年回溯', category: '源头梳理', heat: 96, trend: 'up' },
  { id: 'w2', rank: 2, title: '四年合作时间轴全复盘', category: '来龙去脉', heat: 93, trend: 'up' },
  { id: 'w3', rank: 3, title: '星野文化 · 三方声明时间线', category: '合约争议', heat: 89, trend: 'down' },
  { id: 'w4', rank: 4, title: '被删动态的两次批量回收', category: '外围线索', heat: 72, trend: 'flat' },
  { id: 'w5', rank: 5, title: '关联账号改名时间点统计', category: '证据整理', heat: 64, trend: 'up' },
  { id: 'w6', rank: 6, title: '早期采访原话逐句比对', category: '深度分析', heat: 58, trend: 'flat' },
];

export const timelineNodes = [
  {
    id: 't1',
    stage: '源头',
    time: '三年前 · 11 月',
    title: '最早的一条公开记录出现',
    desc: '一条普通的工作动态，被后来的回看者当作整条线的起点。当时没有人注意。',
  },
  {
    id: 't2',
    stage: '源头',
    time: '两年前 · 04 月',
    title: '合作关系的第一次公开痕迹',
    desc: '双方在同一天发布了风格高度一致的内容，时间差只有 7 分钟。',
  },
  {
    id: 't3',
    stage: '发酵',
    time: '今年 · 03 月',
    title: '关键物料第一次流出',
    desc: '一段 41 秒的差别版本在社区流转，成为后续所有讨论的共同底本。',
  },
  {
    id: 't4',
    stage: '发酵',
    time: '今年 · 05 月',
    title: '话题首次冲上热度榜',
    desc: '讨论从零星补充转为集中梳理，话题墙当天新增 60 余条线索。',
  },
  {
    id: 't5',
    stage: '回应',
    time: '今年 · 08 月',
    title: '双方首次在同一节点作出回应',
    desc: '整条时间线上第一次出现「同日双向回应」，走向从此改变。',
  },
  {
    id: 't6',
    stage: '收尾',
    time: '本月 · 至今',
    title: '声明原文归档，节点顺序重排',
    desc: '被删段落对回时间轴后，多数此前的推测需要重新校准位置。',
  },
];

export const timelineFilters = ['全部', '源头', '发酵', '回应', '收尾'];

export const topicWall = [
  { id: 'p1', label: '# 合约期限争议', count: 128, size: 'lg' },
  { id: 'p2', label: '# 源头三年回溯', count: 96, size: 'lg' },
  { id: 'p3', label: '# 录音差额对照', count: 74, size: 'md' },
  { id: 'p4', label: '# 同日双向回应', count: 61, size: 'md' },
  { id: 'p5', label: '# 旧截图更正', count: 43, size: 'sm' },
  { id: 'p6', label: '# 粉丝站清空', count: 38, size: 'sm' },
  { id: 'p7', label: '# 改名时间点', count: 27, size: 'sm' },
  { id: 'p8', label: '# 早期采访原话', count: 22, size: 'sm' },
  { id: 'p9', label: '# 关联账号梳理', count: 19, size: 'sm' },
  { id: 'p10', label: '# 时间轴可视化', count: 15, size: 'sm' },
];

export const analysisArticles = [
  {
    id: 'a1',
    tag: '源头梳理',
    title: '把四年合作线拆成 12 个节点之后，最可疑的其实是最安静的那一段',
    excerpt: '多数人盯着声量最大的两个月，而时间轴上真正断掉的地方，安静得几乎没有人回头看。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20desk%20flatlay%20with%20stacked%20paper%20timeline%20notes%2C%20brass%20pen%2C%20crimson%20thread%20markers%2C%20soft%20cream%20background%2C%20editorial%20documentary%20photography%2C%20slow%20natural%20light%2C%20calm%20investigative%20mood%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&seq=kd-analysis-01&orientation=landscape',
    author: '编辑部 · 老纪',
    reads: '4.2 万',
    minutes: 9,
  },
  {
    id: 'a2',
    tag: '证据整理',
    title: '同一段录音的两个版本：把 41 秒差额按上下文补回位置',
    excerpt: '我们保留了两次公开的完整时间码，逐句对齐后发现缺口并不在中间，而在最容易被跳过的地方。',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20paper%20evidence%20board%20with%20connected%20pins%20and%20amber%20notes%2C%20warm%20cream%20background%2C%20crimson%20accent%20lines%2C%20editorial%20photography%2C%20soft%20diffused%20light%2C%20detective%20investigation%20mood%2C%20high%20detail%2C%20minimal%20composition&width=800&height=600&seq=kd-analysis-02&orientation=landscape',
    author: '证据组 · 阿栗',
    reads: '3.6 万',
    minutes: 12,
  },
  {
    id: 'a3',
    tag: '走向判断',
    title: '每一次引爆都落在同一个节点上，这大概率不是巧合',
    excerpt: '把四次集中讨论的起点标在同一张时间轴，重合度高到需要专门解释一次。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20cream%20desk%20with%20open%20notebook%20full%20of%20handwritten%20timeline%20sketches%2C%20amber%20highlighter%2C%20crimson%20bookmark%20ribbon%2C%20soft%20window%20light%2C%20editorial%20photography%2C%20calm%20analytical%20mood%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=kd-analysis-03&orientation=landscape',
    author: '分析组 · 小满',
    reads: '2.9 万',
    minutes: 7,
  },
];

export const discussions = [
  {
    id: 'd1',
    avatar: '森',
    author: '森林里的猫',
    badge: '补充线索',
    time: '8 分钟前',
    title: '第 12 个节点的时间差，我这边有另一份对不上的记录',
    body: '我手上这份的发布记录比官方归档版本早 40 分钟左右，不确定是不是同一份文件，先把时间点放这里。',
    replies: 26,
    likes: 143,
    hot: true,
  },
  {
    id: 'd2',
    avatar: '阿',
    author: '阿栗不甜',
    badge: '时间线组',
    time: '31 分钟前',
    title: '把话题墙前五的话题按出现顺序排了一下，顺序很说明问题',
    body: '从「有没有签」到「什么时候到期」，话题位移的路径本身就能看出讨论重心怎么走的。',
    replies: 41,
    likes: 218,
    hot: false,
  },
  {
    id: 'd3',
    avatar: '路',
    author: '路过打个卡',
    badge: '吃瓜群众',
    time: '1 小时前',
    title: '求一个从头看的顺序，前面几波完全没跟上',
    body: '只刷到了后半段，想知道源头那部分从哪条开始看最省事，有整理好的顺序吗。',
    replies: 18,
    likes: 96,
    hot: false,
  },
  {
    id: 'd4',
    avatar: '老',
    author: '老纪的笔记本',
    badge: '编辑部',
    time: '2 小时前',
    title: '更正说明：那条旧截图的时间戳我们标错了',
    body: '已按更正后的时间点重排节点顺序，受影响的三个节点位置都往后挪了，感谢指出。',
    replies: 12,
    likes: 187,
    hot: false,
  },
];

export const footerSections = [
  {
    title: '站内分区',
    links: [
      { label: '今日更新条', href: '#updates' },
      { label: '事件热度榜', href: '#ranking' },
      { label: '来龙去脉时间线', href: '#timeline' },
      { label: '话题标签墙', href: '#topics' },
    ],
  },
  {
    title: '梳理方式',
    links: [
      { label: '按源头回溯', href: '#timeline' },
      { label: '按节点排序', href: '#timeline' },
      { label: '按热度查看', href: '#ranking' },
      { label: '按话题聚类', href: '#topics' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '内容说明', href: '#top' },
      { label: '更正与反馈', href: '#community' },
      { label: '深度分析目录', href: '#analysis' },
      { label: '社区讨论区', href: '#community' },
    ],
  },
];